<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-05-21 23:14:06
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-03-17 16:08:24
-->
<template>
    <div class="ad-content">
        <div class="ad-content-item" v-for="item in adList" >
            <img :src="item.logo" alt="" @click="openDetail(item)">
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getAdvertList} from '@/api/advert';

export default {
    name: 'CardList',
    components: {
    },
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        adList:[]
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            getAdvertList({
                // isInside: 0
            }).then(({ code, data }) => {
                if (code === 0) {
                    this.adList = data.filter(item => item.isInside === 1);
                }
            });
        },
        openDetail(item) {
            // 平台内部链接
            // if (item.isInside === 1) {
            //     this.$router.push({
            //         name: 'Advert',
            //         query: {
            //             id: item.id
            //         }
            //     });
            // } else if (item.isInside === 0 && item.url) {
                const aTag = document.createElement('a');
                let href = item.url;
                aTag.href = href;
                aTag.target = '_blank';
                aTag.click();
            // }
        }
    }
};
</script>

<style lang="scss" scoped>
.ad-content {
    width: 1600px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    margin: 50px 0 40px 0;

    &-item {
        display: inline-block;
        margin-right: 20px;
        flex: 1;
        height: 150px;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }

        &:nth-last-child(1) {
            margin-right: 0;
        }
    }
}

// 小屏
@include mq($small) {
    .ad-content {
        width: 1200px;

        &-item {
            display: flex;
            flex: 1;
            height: 109px;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }

            &:nth-last-child(1) {
                margin-right: 0;
            }
        }
    }
}
</style>
